<template>
  <WdsSelect
    :start-selected="getActiveLanguage()"
    :list="availableLanguages"
    @select-option="handleLanguageSelected"
  />
</template>

<script>
import {ref} from 'vue'
import {WdsSelect} from '@worksome/wds-components'
import { $t } from '@/composables/translation'

const Locales = {
  EN: 'English',
  DA: 'Dansk',
  DE: 'Deutsch',
  FR: 'Français',
}

export default {
  name: 'AuthLanguageSwitcher',
  components: {
    WdsSelect,
  },
  setup() {
    function getActiveLanguage() {
      return window.currentLanguageSelected || 'en'
    }

    function handleLanguageSelected({ value: language }) {
      window.location.replace(`/lang/${language}`)
    }

    const availableLanguages = ref([])

    for (const [key, value] of Object.entries(Locales)) {
      availableLanguages.value.push({
        value: key.toLowerCase(),
        label: $t(value)
      })
    }

    return { getActiveLanguage, availableLanguages, handleLanguageSelected }
  },
}
</script>

